import script from "./TopAdsCabinetPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopAdsCabinetPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopAdsCabinetPanel.vue?vue&type=style&index=0&id=b742553a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b742553a"]])

export default __exports__